module.exports = __webpack_public_path__ + "e18911a2db15d71183e3fe182c66049f.woff2";